import { CheckIcon } from "@heroicons/react/24/outline";
import { Controller } from "react-hook-form";

interface CheckboxInputProps {
  input: {
    name: string;
    value: number;
    validators?: object;
    label?: string;
  };
  form: any;
  isDisabled: boolean;
}

export default function CheckboxInputController({ input, form, isDisabled }: CheckboxInputProps) {
  const { control } = form;

  return (
    <div className="flex items-start space-x-4">
      <Controller
        name={input.name}
        control={control}
        rules={input.validators}
        render={({ field }) => (
            <label htmlFor={input.name} className="select-none cursor-pointer block text-base">
                <input
                id="custom-check"
                checked={field.value === input.value}
                {...field}
                disabled={isDisabled}
                value={field.value}
                type="checkbox"
                className="hidden h-5 w-6 block rounded-lg focus:outline-none accent-[#064e3b] focus-[#064e3b] hover-[#064e3b]" />
                <span className={`relative h-6 w-6 border rounded-md block flex items-center justify-center ${field.value === input.value && 'bg-[#064e3b]'}`}>
                    {field.value === input.value && <CheckIcon className="text-white h-4 w-5 stroke-[3px]" />}
                </span>
                {input.label}
            </label>
        )}
      />
    </div>
  );
}
